import request from "@/utils/request.js"

/*查询线路*/
// 骑行路线列表
export const listCyclingRoute = (pageData, formData) => {
    return request.get(`/cyclingRoute/${pageData.page}/${pageData.pageSize}`, {params: formData})
}

// 删除骑行路线
export const deleteCyclingRoute = (id) => {
    return request.delete(`/cyclingRoute/${id}`)
}

// 新增骑行路线
export const addCyclingRoute = (updateData) => {
    return request.post(`/cyclingRoute`, updateData)
}

// 修改骑行路线
export const editCyclingRoute = (updateData) => {
    return request.put(`/cyclingRoute`, updateData)
}

// 骑行路线详情
export const getCyclingRoute = (id) => {
    return request.get(`/cyclingRoute/${id}`)
}

// 关联标签
export const editCyclingRouteLinkTag = (updateData) => {
    return request.post(`/cyclingRouteTag`, updateData)
}
